<template>
  <div class="dialog-container wt-dialog-container">
    <div v-loading="isMessageDetailLoading">
      <wt-detail-form-buttons :detail-form-buttons.sync="detailFormButtons" @on-detail-button-action="onDetailButtonAction"></wt-detail-form-buttons>
      <wt-detail-form-section ref="formSection" :detail-form-data.sync="detailFormData" :detail-form.sync="detailForm" :readonly="true" />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'Message-view',
  props: ['component-type'],
  isAutoComponent: true,
  data() {
    return {
      formCode: 'MODULES_MESSAGE',
      isSubmitLoading: false,
      formUpdateUrl: '/modules/message/messageUpdate',
      formAddUrl: '/modules/message/messageAdd',
      detailFormButtons: {
        title: '详情',
        elements: [{ name: '创建', key: 'ADD', action: 'ADD', hidden: this.componentType !== 'add' },
          { name: '保存', key: 'EDIT', action: 'EDIT', hidden: this.componentType !== 'edit' },
          { name: '返回', key: 'CLOSE', action: 'CLOSE' }]
      },
      detailForm: {
        title: '基本信息',
        elements: [
          { name: '消息推送内容', key: 'title', type: 'text', disabled: true },
          { name: '消息推送类型', key: 'content', type: 'text', disabled: true },
          { name: '消息推送人员', key: 'type', type: 'custom', disabled: true }]
      }
    }
  },
  created() {
  },
  methods: {
    /*  ------------------------- 按钮  -------------------------  */
    onDetailButtonAction(item) {
      if (item.action === 'CLOSE') {
        this.$emit('on-dialog-action', 'close')
      }
    },
    /*  ------------------------- 网络请求  -------------------------  */
    onWtDialogClose() {
      this.$emit('on-dialog-action', 'close')
    }
  },
  computed: {
    ...mapState({
      isMessageDetailLoading: state => state.message.isMessageDetailLoading,
      detailFormData: state => state.message.messageDetailData
    })
  }
}
</script>

<style scoped>

</style>
